import {
  fetchDeleteNotificationStart,
  fetchDeleteNotificationSuccess,
  fetchDeleteNotificationFailure,
} from "./reducer";

import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { DELETE_NOTIFICATION } from "../../constants/constants";
import { getNotification } from "../GetNotification/thunk";

export const deleteNotification = (id, setLoading) => (dispatch) => {
  setLoading(true);
  dispatch(fetchDeleteNotificationStart());

  determineBaseUrlAndPerformApiCall(
    DELETE_NOTIFICATION(id),
    "DELETE"
  )
    .then((response) => {
      if (!response.error) {
        dispatch(fetchDeleteNotificationSuccess(response));
        dispatch(getNotification(setLoading));
        setLoading(false);
        // toast.success("Notification Deleted Successfully");
      } else {
        dispatch(
          fetchDeleteNotificationFailure(response.error.message)
        );
        setLoading(false);
        toast.error(response.error.message);
      }
    })
    .catch((errorResp) => {
      dispatch(
        fetchDeleteNotificationFailure(
          errorResp?.message || "Something went wrong"
        )
      );

      setLoading(false);
      toast.error(errorResp?.message || "Something went wrong");
    });
};